<template lang="html">
  <div v-bind:class="{ inithide: !show }" class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</template>

<script>
export default {
  props: [
    'show',
  ],
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// loader.vue?4f958ece